export default "__VITE_ASSET__BEW4LUJN__"